import { IconStatusTypes } from '@genial/components';
import { Color } from '@genial/design-tokens';
import { IconographyOptions, IconographyTypes } from '@genial/icons';
import { OrderIconStatusEntity } from '@genial/services';
import { Utils } from '@genial/utils';

type OrderIconStatusProps = Omit<OrderIconStatusEntity, 'isActive'>;

export interface OrderStatusProps {
  icon: IconographyTypes.Option;
  iconColor: string;
  iconSize: Utils.IconTypes.SizeTokens;
  backgroundColor: string;
}

export const getValidatedStatusIconAsSingleIconStatus = (
  status: OrderIconStatusProps,
  testId: string
): IconStatusTypes.SingleIconProps => {
  const {
    icon,
    iconColor: color,
    iconSize: size,
    backgroundColor: bgColor,
  } = getValidatedStatusIcon(status);

  return { bgColor, color, icon, size, testId };
};

export const getValidatedStatusIcon = (status: OrderIconStatusProps): OrderStatusProps => {
  const { icon, iconColor, iconSize, backgroundColor } = status;

  const correctStatusIcon: OrderStatusProps = {
    icon: IconographyOptions.find((option) => option === icon) || 'Info',
    iconColor: iconColor || Color['neutral.darkest'],
    iconSize:
      iconSize && Utils.Icon.Sizes[iconSize] ? (iconSize as Utils.IconTypes.SizeTokens) : 'xxs',
    backgroundColor: backgroundColor || Color['neutral.lightest'],
  };

  return correctStatusIcon;
};
